import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { FerramanetasDetalhe } from "../../shared/components/ferramentasDaListagem/ferramentas-detalhe";
import { BaseLayout } from "../../shared/layouts/base-layout-page";
import {
  GerarMovimentacaoObraFormData,
  gerarMovimentacaoObraSchema,
} from "./schema/gerar-movimentacao-obra.schema";
import { yupResolver } from "@hookform/resolvers/yup";
import { useNavigate, useParams } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { Box, TextField } from "@mui/material";
import { toast } from "react-toastify";
import { toastError } from "../../shared/services/errors/erros-handler";
import { InputFileUpload } from "../../shared/components/formulario/input-file/inputFile";
import InputData from "../../shared/components/formulario/input-data/inputData";
import InputMascarado from "../../shared/components/formulario/input-mascarado/InputMascarado";
import { mascaraMoedaReal } from "../../shared/utils/mascaras/mascaraMoedaReal";
import { movimentacaoObraService } from "./service/movimentacao-obra.service";
import useLoadingStore from "../../shared/store/loading.store"; // Importe o loading store

export function GerarMovimentacaoObra() {
  const methods = useForm<GerarMovimentacaoObraFormData>({
    resolver: yupResolver(gerarMovimentacaoObraSchema),
    defaultValues: {
      idWork: "",
      additionalValue: 0,
      description: "",
    },
  });

  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { setLoading } = useLoadingStore();

  const {
    handleSubmit,
    setValue,
    control,
    formState: { errors },
  } = methods;

  // Use useEffect para setar o valor do ID
  useEffect(() => {
    if (id) {
      setValue("idWork", id);
    }
  }, [id, setValue]);

  const { isPending, mutate } = useMutation({
    mutationFn: async (data: GerarMovimentacaoObraFormData) => {
      setLoading(true, "Estamos quase lá! Só mais um momento...");
      await movimentacaoObraService.gerar(data);
    },
    onSuccess: () => {
      toast.success("Movimentação gerada com sucesso");
      navigate(`/obra/detalhe/${id}`);
    },
    onError: (err: any) => {
      toastError(err);
    },
    onSettled: () => {
      setLoading(false); // Para o loading independente do resultado
    },
  });

  return (
    <BaseLayout title="Gerar Movimentação">
      <FerramanetasDetalhe
        mostraBotaoNovo={false}
        mostraBotaoVoltar={true}
        mostraBotaoApagar={false}
        mostraBotaoSalvarEVoltar={false}
        mostrarBotaoAdicional={false}
        textBotaoSalvar="Gerar"
        aoClicarBotaoSalvar={handleSubmit((formData) => mutate(formData))}
        aoClicarBotaoVoltar={() => navigate(`/obra/detalhe/${id}`)}
      />
      <Box
        component="form"
        onSubmit={handleSubmit((formData) => mutate(formData))}
        padding="20px 0"
        display="flex"
        flexDirection="column"
        height="calc(100% - 100px )"
      >
        <Box display="grid" gridTemplateColumns="1fr 1fr" gap={2}>
          <InputMascarado
            name="additionalValue"
            methods={methods}
            label="Informe o valor adicional"
            mask={mascaraMoedaReal}
          />

          <InputData
            name="newEstimatedEndDate"
            label="Informe a nova data de término estimada"
            methods={methods}
          />
        </Box>

        <TextField
          sx={{ margin: "20px 0 30px" }}
          label="Descrição"
          multiline
          minRows={3}
          {...methods.register("description")}
          error={!!errors.description}
          helperText={errors.description?.message}
        />

        <InputFileUpload
          name="contract"
          label="Adicione um contrato nos seguintes formatos (PDF, JPG ou PNG)"
          methods={methods}
        />
      </Box>
    </BaseLayout>
  );
}